import React, { Fragment } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Row, Col, Container } from 'reactstrap'
import PropTypes from 'prop-types'
import {
  Placeholder,
  H3,
  H5,
  Paragraph,
  TextContainer
} from '../../GlobalStyles'
import styled from 'styled-components'
import { IconLink } from '../../common/Links'
import theme from '../../theme'
import Img from 'gatsby-image'
import { prop } from 'ramda'
import AppleStore from '../../../images/apple-store-reversed.svg'
import GooglePlay from '../../../images/google-play-reversed.svg'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../constants'

export const CardWrapper = styled.div`
  position: relative;
  background-color: ${p => p.color || p.theme.colors.white};
  height: 100%;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
`

export const CardInner = styled.div`
  > img {
    max-width: 100%;
  }
`

export const CardCol = styled(Col)`
  margin-bottom: 30px;
`
export const CardText = styled.div`
  padding: 36px 24px;
  text-align: left;
`

const ButtonImageLink = styled.a`
  @media (max-width: 992px) {
    margin-top: 20px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${p => p.justifyContent || 'flex-start'};
  width: 100%;
  margin-top: 32px;
`

export const CardsSecondary = () => (
  <StaticQuery
    query={graphql`
      query {
        Tiles1: file(relativePath: { eq: "OurCoaches/Card1.jpg" }) {
          ...optimizedImage
        }
        Tiles2: file(relativePath: { eq: "OurCoaches/Card2.jpg" }) {
          ...optimizedImage
        }
        Tiles3: file(relativePath: { eq: "OurCoaches/Card3.jpg" }) {
          ...optimizedImage
        }
      }
    `}
    render={data => (
      <Fragment>
        <TextContainer>
          <Container>
            <H3 color={theme.colors.navy} marginBottom='48px'>
              The Benefits of PGA.Coach
            </H3>
            <Row>
              <CardCol xs='12' xl='4' md='6'>
                <CardWrapper>
                  {prop('Tiles1', data) ? (
                    <Img fluid={data.Tiles1.childImageSharp.fluid} />
                  ) : (
                    <Placeholder />
                  )}
                  <CardInner>
                    <CardText>
                      <H5 textAlign='left' color={theme.colors.navy}>
                        Ease of Entry
                      </H5>
                      <Paragraph>
                        ADM introduces the right aspects of play in a structure
                        that is fun, engaging, and progressively challenging
                        allowing golfers of all ages to experience the
                        challenges and joys of our sport for years to come.
                      </Paragraph>
                      <ButtonsContainer>
                        <IconLink
                          url='https://pgacoach.lightspeedvt.com/'
                          color={theme.colors.navy}
                          justifyContent='flex-start'
                        >
                          Get Started Here
                        </IconLink>
                      </ButtonsContainer>
                    </CardText>
                  </CardInner>
                </CardWrapper>
              </CardCol>
              <CardCol xs='12' xl='4' md='6'>
                <CardWrapper>
                  {prop('Tiles2', data) ? (
                    <Img fluid={data.Tiles2.childImageSharp.fluid} />
                  ) : (
                    <Placeholder />
                  )}
                  <CardInner>
                    <CardText>
                      <H5 textAlign='left' color={theme.colors.navy}>
                        Tools for Success
                      </H5>
                      <Paragraph>
                        Through the PGA Coach App, PGA and LPGA Members can get
                        access to activity planning, notetaking and assessment
                        tools that make it easy to quickly start applying ADM
                        principles.
                      </Paragraph>
                      <ButtonsContainer justifyContent='space-around'>
                        <ButtonImageLink href={myPgaIOSUrl}>
                          <img src={AppleStore} alt='Apple' />
                        </ButtonImageLink>
                        <ButtonImageLink href={myPgaAndroidUrl}>
                          <img src={GooglePlay} alt='GooglePlay' />
                        </ButtonImageLink>
                      </ButtonsContainer>
                    </CardText>
                  </CardInner>
                </CardWrapper>
              </CardCol>
              <CardCol xs='12' xl='4' md='6'>
                <CardWrapper>
                  {prop('Tiles3', data) ? (
                    <Img fluid={data.Tiles3.childImageSharp.fluid} />
                  ) : (
                    <Placeholder />
                  )}
                  <CardInner>
                    <CardText>
                      <H5 textAlign='left' color={theme.colors.navy}>
                        Building Business
                      </H5>
                      <Paragraph>
                        ADM was designed by sports scientists to align physical
                        and psychological development to stages delivering
                        appropriate skills and exercise at the appropriate time.
                      </Paragraph>
                      <ButtonsContainer>
                        <IconLink
                          url='https://pga.com/coach'
                          color={theme.colors.navy}
                          justifyContent='flex-start'
                        >
                          Log In to Get Started
                        </IconLink>
                      </ButtonsContainer>
                    </CardText>
                  </CardInner>
                </CardWrapper>
              </CardCol>
            </Row>
          </Container>
        </TextContainer>
      </Fragment>
    )}
  />
)

Row.propTypes = {
  noGutters: PropTypes.bool,
  form: PropTypes.bool
}

export default CardsSecondary
